import {
  API_CALL,
} from './actionConstants'
import {
  FETCH_REFER_EARN_OPTIONS,
  FETCH_REFERRAL_LOGS,
  FETCH_REFERRAL_CODE,
  FETCH_REFERRAL_VALUE,
} from './apiActionConstants'
import {
  getEarnOptions,
  getReferralLogs,
  getReferralValue,
} from 'marketing/api'
import { getCodeByUserId } from 'api/promo'
import { AppAction } from './types/ActionTypes'

export function fetchEarnOptions(region: string): AppAction {
  return {
    type: API_CALL,
    api: FETCH_REFER_EARN_OPTIONS,
    request: () => getEarnOptions(region),
  }
}

export function fetchReferralLogs(accessToken?: string): AppAction {
  return {
    type: API_CALL,
    api: FETCH_REFERRAL_LOGS,
    request: () => getReferralLogs(accessToken),
  }
}

export function fetchMyReferralCode(memberId: string, accessToken?: string): AppAction {
  return {
    type: API_CALL,
    api: FETCH_REFERRAL_CODE,
    request: () => getCodeByUserId(memberId, accessToken),
  }
}

export function fetchReferralValue(region: string): AppAction {
  return {
    type: API_CALL,
    api: FETCH_REFERRAL_VALUE,
    request: () => getReferralValue(region),
  }
}
